function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.85723 7.17606C9.23477 5.93711 9.93725 4.72007 9.93725 3.53752C9.93725 2.08124 8.98735 0.998854 7.72574 0.993626C7.14834 0.993622 6.82978 1.0525 6.4502 1.23829C6.21672 1.35258 6.00957 1.50686 5.82889 1.70292L5.46661 2.09602L5.10102 1.70601C4.9243 1.5175 4.72016 1.36665 4.48918 1.25241C4.09814 1.059 3.75836 0.993622 3.20697 0.993622C1.92957 0.993622 0.993652 2.06075 0.993652 3.53752C0.993652 4.72007 1.69613 5.93711 3.07367 7.17606C3.82471 7.85154 4.79023 8.52659 5.46545 8.88073C6.14068 8.52659 7.1062 7.85154 7.85723 7.17606Z",
  fill: "#3EC1FF"
});

function SvgFavouriteOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "favourite-on",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOn);
export default __webpack_public_path__ + "static/media/favourite-on.fa19d9e5.svg";
export { ForwardRef as ReactComponent };